// getDisplayCurrencyCode.js
'use strict';

const CURRENCY_DISPLAY_MAP = {
  CNY: 'RMB',
};

/**
 * Get display currency code
 * @param {Object} params
 * @param {string} params.currency - Currency code from API.
 * @return {string} - The display currency code.
 */
const getDisplayCurrencyCode = ({ currency = '' }) => {
  if (!currency) return '';
  const upper = currency.toUpperCase();
  return CURRENCY_DISPLAY_MAP[upper] || upper;
};

export default getDisplayCurrencyCode;
